import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Row,
  Col,
  Label,
  Input,
  FormText} from 'reactstrap';
import moment from "moment/moment";
import DateInput from "../DateInput";
import MoneyInput from "../MoneyInput";
import MoneyDisplay from "../MoneyDisplay";
import CampaignPaymentForm from "../../../routes/GuidedCampaignReview/components/CampaignPaymentForm";
import {DEFAULT_TIMEZONE} from "../../../config";
import {loadIOSForAgency} from "../../redux/entities/actions";

class ExtendCampaignModal extends Component {
  constructor(props) {
    super(props);
    this.state = {validationMessages: {}, additionalThresholdAmount: 0, resumeDate: moment().startOf("day"), endDate: false, hasEndDate: false,selectedIOs: []};
  }

  componentDidMount(){
  }

  componentWillReceiveProps(nextProps){
    if(this.props.campaignId !== nextProps.campaignId){
      if (nextProps.campaign) {
        this.props.loadIOSForAgency(nextProps.campaign.agencyId)
      }
    }
  }

  handleChangeAdditionalThresholdAmount(value) {
    this.setState({additionalThresholdAmount: value});
  }

  handleHasEndDateClick(event){
    if(event.target.checked){
      if(!this.state.resumeDate){
        this.setState({
          hasEndDate:true
        });
      } else {
        const oneWeekFromResume = this.state.resumeDate.clone().add(1,'weeks');

        this.setState({
          hasEndDate:true,
          endDate:this.state.endDate || oneWeekFromResume
        });
      }
    } else {
      this.setState({
        endDate:false,
        hasEndDate:false
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log(event)

    const validationMessages = {};

    if(!this.state.additionalThresholdAmount){
      validationMessages['additionalThresholdAmount'] = 'Additional Threshold is required';
    }
    if(parseInt(this.state.additionalThresholdAmount) < 0){
      validationMessages['additionalThresholdAmount'] = 'Threshold may only be increased';
    }

    const selectedIOs = this.props.ios.filter(io => this.state.selectedIOs.indexOf('' + io.id) !== -1)
    let IOAmount = selectedIOs && selectedIOs.length > 0 ? selectedIOs.reduce((a,b) => a+b) : 0;
    if(parseInt(this.state.additionalThresholdAmount) > IOAmount){
      validationMessages['additionalThresholdAmount'] = 'Selected IO amount should be greater than Additional Threshold ';
    }

    // if(parseInt(this.state.additionalThresholdAmount) > 10000){
    //   validationMessages['additionalThresholdAmount'] = 'Not enough available funds. Please decrease campaign threshold value or add additional funds to your account balance.';
    // }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      return
    } else {
      this.setState({validationMessages:{}});
    }

    const isResumeDisabled = this.props.status === 'active' || this.props.status === 'ready'
    this.props.onSubmit({
      campaignId: this.props.campaignId,
      campaign: this.props.campaign,
      newLifetimeBudget: String(Number(this.props.currentThreshold) + Number(this.state.additionalThresholdAmount)),
      additionalThresholdAmount: Number(this.state.additionalThresholdAmount),
      resumeDate: this.state.resumeDate && !isResumeDisabled ? this.state.resumeDate.add(this.state.resumeDate.utcOffset(), 'm').utc().add(12, 'hours').format('x') : '',
      endDate: this.state.endDate ? this.state.endDate.add(this.state.endDate.utcOffset(), 'm').utc().add(12, 'hours').format('x') : '',
      selectedIOs: selectedIOs
    })
      .then((res) => {
        // console.log("ExtendCampaignModal onSubmit success")
      })
      .catch((error)=>{
        // console.log("ExtendCampaignModal onSubmit fail")
        validationMessages['responseError'] = error.message;
        this.setState({validationMessages:validationMessages});
      });
  }

  handleIOsSelected(e){
    const values = [...e.target.selectedOptions].map(opt => opt.value)
    this.setState({selectedIOs:values})
  }


  render(){
    const {additionalThresholdAmount, resumeDate, endDate, hasEndDate, validationMessages} = this.state;
    const {currentThreshold, amountSpent, status, launchDate} = this.props;
    const isResumeDisabled = status === 'active' || status === 'ready'
    return (
      <div>
        <Modal isOpen={this.props.isModalOpen} className='ExtendCampaignModal'>
          <Form onSubmit={(data) => this.handleSubmit(data)}>
            <ModalHeader>To extend this Experience, please provide the following information:</ModalHeader>
            <ModalBody>
              <FormGroup row>
                <Label for="currentThreshold" sm={6}>Current Threshold:</Label>
                <span className='extend-form-value-item'><MoneyDisplay id="currentThreshold" name='currentThreshold'>{currentThreshold}</MoneyDisplay></span>
              </FormGroup>
              <FormGroup row>
                <Label for="amountSpent" sm={6}>Amount Spent:</Label>
                <span className='extend-form-value-item'><MoneyDisplay id="amountSpent">{amountSpent}</MoneyDisplay></span>
              </FormGroup>
              <MoneyInput row
                          id='additionalThresholdAmount'
                          name='additionalThresholdAmount'
                          label='Add Threshold Amount:'
                          labelSm={4}
                          defaultValue={additionalThresholdAmount}
                          placeholder='50'
                          warning={validationMessages['additionalThresholdAmount']}
                          onChange={(value) => this.handleChangeAdditionalThresholdAmount(value)}
                          onBlur={(e) => this.handleChangeAdditionalThresholdAmount(e.target.value)}
              />
              <FormGroup row>
                <Label for="newThresholdAmount" sm={6}>New Threshold:</Label>
                <span className='extend-form-value-item'><MoneyDisplay id='newThresholdAmount'>{parseInt(currentThreshold) + parseInt(additionalThresholdAmount)}</MoneyDisplay></span>
              </FormGroup>
              <FormGroup row>
                <Label for="ios" sm={6}>IOs:</Label>
                <span className='extend-form-value-item'>
                <Input
                    name='ios'
                    type='select'
                    value={this.state.selectedIOs}
                    onChange={(e) => this.handleIOsSelected(e)}
                    multiple
                >
                  { this.props.ios && this.props.ios.map( t => (
                          <option value={t.id} key={t.id}>
                            {`IO: ${t.note}} $${t.amount} - ${moment(t.createdDate).tz(DEFAULT_TIMEZONE).format('MMM D, YYYY')}`}
                          </option>
                      )
                  )}
                </Input>
                </span>
              </FormGroup>
              <FormGroup row>
                <Label for="resumeDate" sm={4}>Resume Date:</Label>
                <ReactDatePicker
                  id='resumeDate'
                  name='resumeDate'
                  className='form-control'
                  minDate={moment().startOf("day")}
                  selected={isResumeDisabled ? null : resumeDate}
                  placeholderText={isResumeDisabled ? '' : moment().format('MM/DD/YYYY')}
                  onChange={(d) => this.setState({resumeDate:d})}
                  disabled={isResumeDisabled}
                />
                { validationMessages['resumeDate'] && (
                  <FormText className='DangerFeedback'>{validationMessages['resumeDate']}</FormText>
                )}
              </FormGroup>
              <Row>
                <Col xs='8'>
                  <FormGroup row>
                    <Label for="endDate" sm={6}>End Date:</Label>
                    <ReactDatePicker
                      id='endDate'
                      name='endDate'
                      className='form-control'
                      minDate={resumeDate || moment().startOf("day")}
                      selected={endDate && hasEndDate ? (resumeDate > endDate ? moment(resumeDate) : moment(endDate)) : null}
                      placeholderText={hasEndDate ? moment().format('MM/DD/YYYY') : ''}
                      onChange={(d) => this.setState({endDate:d})}
                      disabled={!hasEndDate}
                    />
                    { validationMessages['endDate'] && (
                      <FormText className='DangerFeedback'>{validationMessages['endDate']}</FormText>
                    )}
                  </FormGroup>
                </Col>
                <Col xs='4'>
                  <FormGroup check row>
                    <Label id='HasEndDateCheckbox' check>
                      <Input
                        type='checkbox'
                        checked={hasEndDate}
                        onChange={(e) => this.handleHasEndDateClick(e)}
                      />
                      Has end date
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs='12' className='LaunchDateWarning'>
                  {validationMessages['responseError'] && (
                    <FormText className='DangerFeedback'>{validationMessages['responseError']}</FormText>
                  )}
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <input type="submit" value="Submit" color="primary" className="btn btn-primary" />
              <Button color="secondary" onClick={this.props.onCancel}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    );
  }
}

ExtendCampaignModal.propTypes = {
  onSubmit:PropTypes.func,
  onCancel:PropTypes.func,
  currentThreshold:PropTypes.number,
  amountSpent:PropTypes.number,
  validationMessage:PropTypes.string,
  isModalOpen:PropTypes.bool
};

ExtendCampaignModal.defaultProps = {
  onSubmit:() => {},
  onValidate:() => {},
  onValidateError:() => {},
  onValidateSuccess:() => {},
  allowAutoComplete:true
};

export default ExtendCampaignModal;



// WEBPACK FOOTER //
// ./src/shared/components/ExtendCampaignModal/ExtendCampaignModal.js